import { HostServices } from '@ally/federated-types'

type FeatureFlags = HostServices['featureFlags']

type RedirectConfig = {
  match(location: Location, featureFlags: FeatureFlags): boolean
  redirectURL(location: Location): string
}

export const autoRedirects: RedirectConfig[] = [
  // Auto Details
  {
    match: (location, featureFlags): boolean => {
      const enabled = featureFlags.auto.variation(
        'ff-auto-ember-react-migration',
        false,
      )
      if (!enabled) return false
      return [
        /^\/sso\/auto\/accounts\/.+$/,
        /^\/sso\/auto\/payment-options\/.+$/,
      ].some(regex => regex.test(location.pathname))
    },
    redirectURL: (location): string => {
      return `${location.pathname.replace(/^\/sso/, '')}${location.search}`
    },
  },
  // Auto Payments
  {
    match: (location, featureFlags): boolean => {
      const enabled = featureFlags.auto.variation(
        'ff-auto-ember-react-migration',
        false,
      )
      return enabled && /^\/sso\/auto\/payments(\/.+)?$/.test(location.pathname)
    },
    redirectURL: (location): string => {
      const sp = new URLSearchParams(location.search)
      const id = sp.get('id')
      sp.delete('id')
      const restPath = location.pathname.replace(/^\/sso\/auto\/payments/, '')
      const restSearch = sp.toString()
      return `/auto/payments${id ? '/'.concat(id) : ''}${restPath}${
        restSearch ? '?'.concat(restSearch) : ''
      }`
    },
  },
]
